import type { Alert } from '@aloft/toolkit-shared';
import {
  orUndefined,
  schAlertType,
  schAloftPrice,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import type { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

const MESSAGE = 'ARV is not greater than AIV';
const TIP =
  'The After-Repair Value must be greater than the As-Is Value, unless the appraiser overrides this check with justification on the Reconciliation page.';
const TARGET_CELL_KEY = 'reconciliation:opinionOfMarketValue';

export const arvBelowAiv: AlertDefinition = ({
  order,
  reconciliation,
  reconciliationCommentary,
}) => {
  if (!order.hasArvOption) return [];

  const aiv = orUndefined(schAloftPrice.parse)(reconciliation.opinionOfMarketValue);
  const arv = orUndefined(schAloftPrice.parse)(reconciliation.opinionOfAfterRepairValue);
  if (!aiv || !arv) return [];
  if (aiv.lt(arv)) return [];

  const hasOverride =
    reconciliation.arvBelowAivOverride &&
    Boolean(reconciliationCommentary?.arvBelowAivOverrideCommentary?.trim());
  if (hasOverride) return [];

  return [
    {
      type: schAlertType.enum.arvBelowAiv,
      status: 'active',
      severity: 'error',
      orderType: ['appraisify'],
      message: MESSAGE,
      propertyID: 'subject',
      fixingInfo: {
        tips: TIP,
        pairedCostRouteItem: schPairedCostRouteItem.enum.reconciliation,
        fixingMethod: ['action'],
        commentAlwaysRequired: false,
        targetCellKey: TARGET_CELL_KEY,
      },
      triggers: getAlertTriggers({
        fixRoute: schPairedCostRouteItem.enum.reconciliation,
        order,
      }),
    } as Alert,
  ];
};
